module.exports = __webpack_public_path__ + "img/inference.fca3b255.svg";